module.exports = __webpack_public_path__ + "img/result-restore-btn.41e67434.png";